<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-list'}"
	[headerText]="data.titleToken | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<sim-admin-settings-scroll-entries-con
			[getScrollEntryText]="getItemName"
			(removeEntryEmitter)="removeSelectedItem($event)"
			[scrollEntries]="selectedItems"
		>
			<mat-form-field class="full-width-form" color="accent">
				<mat-label>
					{{ T.GENERIC_LIST_DIALOG_AVAILABLE_ITEMS | translate }}
				</mat-label>
				<mat-select [ngModel]="selectedItemId" (ngModelChange)="addSelectedItem($event)">
					@for (value of unassignedItems; track value) {
						<mat-option [value]="value.id">
							{{ value.name }}
						</mat-option>
					}
					<mat-option [value]="null">
						{{ T.GENERIC_LIST_DIALOG_NO_ITEM | translate }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</sim-admin-settings-scroll-entries-con>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="close()"
			[color]="'warn'"
			[icon]="{fontSet: 'fal', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CLOSE | translate"
		/>

		<sim-button
			(onClick)="ok()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CONFIGURATION_EDITOR_CAMERA_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
